//
//
//
//

import mixin from '@/mixins'
import GlobalApi from "../api/global";

export default {
  name: 'Web',
  mixins: [mixin],
  data () {
    return {
      txt: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    init() {
      const tag = this.$route.query.tag
      window.localStorage.setItem("appType", this.$route.query.appType);
      console.log('hhh---,tag', tag)
      GlobalApi.getInfoByTag({ tag: tag }).then(data => {
        if (data.Status === 200) {
          this.txt = data.Result.content
          console.log('hhh---,txt:', this.txt)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Web.vue